import { Trash2 } from 'lucide-react';

import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';

type PresetQuestionsListProps = {
  questions: string[];
  onChange: (questions: string[]) => void;
};

export function PresetQuestionsList({
  questions,
  onChange,
}: PresetQuestionsListProps) {
  const normalizedQuestions = questions.length > 0 ? questions : [''];

  const handleQuestionChange = (index: number, value: string) => {
    const nextQuestions = [...normalizedQuestions];
    nextQuestions[index] = value;
    onChange(nextQuestions);
  };

  const handleDelete = (index: number) => {
    if (normalizedQuestions.length <= 1) {
      return;
    }

    onChange(normalizedQuestions.filter((_, currentIndex) => currentIndex !== index));
  };

  const handleAddQuestion = () => {
    if (normalizedQuestions.length < 5) {
      onChange([...normalizedQuestions, '']);
    }
  };

  return (
    <div className="space-y-3">
      {normalizedQuestions.map((question, index) => (
        <div key={index} className="flex items-center gap-2">
          <Input
            type="text"
            value={question}
            onChange={(event) => handleQuestionChange(index, event.target.value)}
            className="flex-1"
            placeholder="Type your question"
          />
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => handleDelete(index)}
            className="text-muted-foreground hover:text-destructive"
            disabled={normalizedQuestions.length <= 1}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ))}

      {normalizedQuestions.length < 5 && (
        <Button type="button" variant="outline" onClick={handleAddQuestion}>
          + Add question ({normalizedQuestions.length}/5)
        </Button>
      )}
    </div>
  );
}
